import React, { PureComponent } from 'react';

import ButtonDropdown from '../../components/ButtonDropdown';

/**
 * Button with dropdown menu container component.
 * Wraps the button in state to control dropdown visibility.
 */
class ButtonDropdownContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownVisible: false,
    };
  }

  handleClick = () => {
    this.toggleDropdownVisibility();
  };

  handleMouseEnter = () => {
    this.setState({
      dropdownVisible: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      dropdownVisible: false,
    });
  };

  toggleDropdownVisibility = () => {
    this.setState({
      dropdownVisible: true,
    });
  };

  render() {
    const { dropdownVisible } = this.state;
    return (
      <ButtonDropdown
        dropdownVisible={dropdownVisible}
        onClick={this.handleClick}
        onLinkClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        {...this.props}
      />
    );
  }
}

export default ButtonDropdownContainer;
